import { createContext } from 'react'

export type MetaContextProps = {
  defaultTitle: string | undefined
  titleTemplate: string | undefined
}

export const MetaContext = createContext<MetaContextProps>({
  defaultTitle: undefined,
  titleTemplate: undefined,
})
